var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 10,
  viewBox: "0 0 15 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.1405 0.532227L7.5 5.77752L12.859 0.532227L14.5 2.14605L7.5 9.03223L0.5 2.14605L2.1405 0.532227Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;